import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { DateDisplay } from "../../DateDisplay";
import { UserAuditHistoryResponse } from "../../../models/Administration";
import { camelToTitleCase } from "../../../utils";
import { Grid } from "@material-ui/core";

interface UserAuditHistoryStepDisplayCardProps {
	//The audit history step to be displayed in the card.
	AuditHistoryStep: UserAuditHistoryResponse;
}

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: theme.spacing(0.5),
		width: "100%",
	},
	cardContent: {
		padding: theme.spacing(1),
	},
}));

/**
 * Takes in a audit history step and displays various details of that step such as the
 * product, role, and date as well as the user or script enacting the change.
 * @param props
 */
export const UserAuditHistoryStepDisplayCard = (props: UserAuditHistoryStepDisplayCardProps) => {
	const classes = useStyles();

	return (
		<Card className={classes.card}>
			<div className={classes.cardContent}>
				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
					<h6>{camelToTitleCase(props.AuditHistoryStep.actionType.toString())}</h6>
					<span style={{ justifySelf: "flex-end" }}>
						<div>
							<DateDisplay date={props.AuditHistoryStep.actionDate}></DateDisplay>
						</div>
						<div style={{ fontSize: 11 }}>{props.AuditHistoryStep.actionUser}</div>
					</span>
				</div>
				<Grid container>
					<Grid item xs={4}>
						{props.AuditHistoryStep.productName && (
							<span>
								<span style={{ fontWeight: "bold" }}>Product: </span> {props.AuditHistoryStep.productName}
							</span>
						)}
					</Grid>
					<Grid item xs={6}>
						{props.AuditHistoryStep.roleName && (
							<span>
								<span style={{ fontWeight: "bold" }}> Role: </span> {props.AuditHistoryStep.roleName}
							</span>
						)}
					</Grid>
				</Grid>
			</div>
		</Card>
	);
};
